<template>
  <div class="product__view vs-con-loading__container">
    <div class="product__view_navbar">
      <TopNavBar />
    </div>

    <div class="product__details p-8">
      <!-- go back btn -->
      <div class="backToBtn flex font-bold text-black items-center">
        <feather-icon icon="ArrowLeftIcon" svgClasses="mr-2" />
        <router-link
          :to="{
            name: 'marketlist'
          }"
          class="font-bold text-black hover:underline text-sm"
        >
          Back To result
        </router-link>
      </div>

      <!-- ad image -->
      <div class="adImage mt-8 w-3/5 mx-auto">
        <img @click="$router.push({ name: 'contactus' }).catch(() => {})" class="cursor-pointer" src="@/assets/images/banners/image1.png" />
      </div>

      <div class="vx-row mt-8" v-if="product">
        <!-- product details -->
        <div class="vx-col w-full lg:w-2/3">
          <!-- product name -->
          <div class="productName md:flex md:justify-between font-bold text-3xl text-black">
            <div class="product_name">{{ product.products_product_name }}</div>
            <div class="product_price">$ {{ product.products_sales_price | currencyFilter }}</div>
          </div>

          <!-- product images -->
          <ImageSlider
            class="mt-3"
            :options="{ perPage: 1, autoplay: false, paginationEnabled: true, navigationEnabled: true, loop: true, centerMode: true }"
            :slides="productImages.length > 0 ? productImages : productdefaultImages"
            :classes="'productImage'"
          />

          <!-- product details -->
          <div class="product__details mt-5">
            <vs-card>
              <div slot="header">
                <h3 class="font-bold">Details</h3>
              </div>
              <div>
                <vs-table stripe noDataText="" :data="[]">
                  <template>
                    <vs-tr>
                      <vs-td>
                        <p><span class="font-bold text-lg">Weight type : </span>{{ product.products_weight_type }}</p>
                      </vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td>
                        <p><span class="font-bold text-lg">Quantity : </span>{{ product.products_quantity | weightFilter }}</p>
                      </vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td>
                        <p><span class="font-bold text-lg">Batch Number : </span>{{ product.batch_batch_number }}</p>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </vs-card>
          </div>

          <div class="product__description">
            <h4 class="font-bold">Description</h4>
            <p class="mt-3">{{ product.products_description ? product.products_description : 'No Description' }}</p>
          </div>
        </div>

        <div class="vx-col w-full lg:w-1/3">
          <!-- contact form -->
          <vs-card>
            <div slot="header">
              <h3 class="flex"><feather-icon icon="MailIcon" svgClasses="mr-2" /> Contact The Seller</h3>
            </div>
            <div>
              <vs-textarea v-model="sellerMessage" height="100px" name="Message" v-validate="'required'" />
              <span class="text-danger text-sm" v-show="errors.has('Message')">{{ errors.first('Message') }}</span>
            </div>
            <div slot="footer">
              <vs-button type="filled" color="success" :disabled="!validateForm" @click="sendSellerMessage">Send Message</vs-button>
            </div>
          </vs-card>

          <!-- about seller -->
          <vs-card>
            <div slot="header">
              <h3 class="flex"><feather-icon icon="CalendarIcon" svgClasses="mr-2" /> About The Seller</h3>
            </div>
            <div>
              <div class="seller_details text-lg">
                <p><span class="font-bold">Role Type</span> : {{ product.role_role_name }}</p>
                <p><span class="font-bold">Member Since</span> : {{ moment(product.parent_users_created_at).format('YYYY') }}</p>
                <p><span class="font-bold"># of Listing In Marketplace</span> : {{ sellers_total_product }}</p>
              </div>
            </div>
          </vs-card>
        </div>
      </div>

      <!-- ad image -->
      <div class="adImage mt-8 w-3/5 mx-auto">
        <img @click="$router.push({ name: 'contactus' }).catch(() => {})" class="cursor-pointer" src="@/assets/images/banners/image1.png" />
      </div>

      <!-- similar product list -->
      <SimilarProductList v-if="similar_products.length" class="mt-8 mb-8" :products="similar_products" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import TopNavBar from '@/views/marketplace/components/TopNavbar.vue'
import ImageSlider from '@/views/marketplace/components/ImageSlider.vue'
import SimilarProductList from '@/views/marketplace/components/SimilarProductList.vue'
import { weightMixins } from '@/utils/weightType'
import { paymentMixins } from '@/utils/paymentTypes'
import { validateMixins } from '@/mixins/validate'
import Image1 from '@/assets/images/products/pr_default.jpg'

export default {
  name: 'ProductView',

  components: {
    TopNavBar,
    ImageSlider,
    SimilarProductList
  },

  data() {
    return {
      productdefaultImages: [
        {
          image_path: Image1
        }
      ],
      sellerMessage: ''
    }
  },

  mixins: [weightMixins, paymentMixins, validateMixins],

  async mounted() {
    const { id } = this.$route.params

    await this.getProductDetailsById(id)
  },

  computed: {
    ...mapState('marketplace', ['product', 'similar_products', 'sellers_total_product', 'productImages', 'loading']),

    // validate form
    validateForm() {
      return !this.errors.any()
    }
  },

  methods: {
    moment,
    ...mapActions('marketplace', { get_marketplace_product_by_id: 'get_market_place_product_by_id', send_seller_message: 'send_message_to_seller' }),

    // get product details
    async getProductDetailsById(id) {
      try {
        await this.get_marketplace_product_by_id(id)
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },

    // send seller message
    async sendSellerMessage() {
      if (!(await this.$validator.validate())) {
        return false
      }

      try {
        const payload = {
          productId: this.product.products_id,
          message: this.sellerMessage
        }

        const { message } = await this.send_seller_message(payload)

        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })

        this.sellerMessage = ''
        this.resetForm()
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    }
  },

  filters: {
    // currencyFilter rounded to 2 point
    currencyFilter(value) {
      return paymentMixins.methods.mathRound(Number(value), 2)
    },

    //weightFilter rounded conversation
    weightFilter(value) {
      return weightMixins.methods.mathRound(Number(value), 3)
    }
  },

  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '.product__view',
          scale: 0.45,
          color: 'primary'
        })
      } else {
        this.$vs.loading.close('.product__view > .con-vs-loading')
      }
    }
  }
}
</script>

<style lang="scss">
.product__view {
  .vs-card--content {
    margin-bottom: unset;
  }
  .vs-card--footer {
    transform: unset !important;
    margin-top: unset;
  }
}
</style>
